module.exports = __webpack_public_path__ + "static/media/iconhome.73449653.svg";